var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dragVerify"},[_c('div',{staticClass:"head"},[_c('span',[_vm._v("请完成安全验证")]),_c('i',{staticClass:"iconfont icon-guanbiicon",on:{"click":_vm.closeVerify}})]),_c('div',{attrs:{"id":"captcha"}})])}
var staticRenderFns = []

export { render, staticRenderFns }